import {isLoadingProcessor, isNotLoadingProcessor} from '_app/shared/processors/isLoadingProcessors';
import * as actionTypes from './htmlMediaContentConstants';

const initialState = {
	content: null,
	isLoading: undefined,
	errorInfo: undefined
};

const htmlMediaContentReducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.HTML_MEDIA_CONTENT_FETCH_REQUEST: {
			return {
				...isLoadingProcessor(state)
			};
		}

		case actionTypes.HTML_MEDIA_CONTENT_FETCH_SUCCESS: {
			return {
				...isNotLoadingProcessor(state),
				content: action.data
			};
		}

		case actionTypes.HTML_MEDIA_CONTENT_FETCH_FAILURE: {
			return {
				...isNotLoadingProcessor(state),
				errorInfo: action.errorInfo,
				content: null
			};
		}

		default:
			return state;
	}
};

export default htmlMediaContentReducer;